import styled from "styled-components";
import { thirdColor, primaryColor, secondaryColor } from "../../../config";

export const Wrapper = styled.div`
  height: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  position: relative;
  overflow-x: hidden;

  .fadeInDown {
    -webkit-animation-name: fadeInDown;
    animation-name: fadeInDown;
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }
  @-webkit-keyframes fadeInDown {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(0, -100%, 0);
      transform: translate3d(0, -100%, 0);
    }
    100% {
      opacity: 1;
      -webkit-transform: none;
      transform: none;
    }
  }
  @keyframes fadeInDown {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(0, -100%, 0);
      transform: translate3d(0, -100%, 0);
    }
    100% {
      opacity: 1;
      -webkit-transform: none;
      transform: none;
    }
  }

  .login-page {
    display: flex;
    direction: ltr; /* keep flex order predictable; form content sets its own dir */
    flex-direction: ${({ theme }) =>
      theme?.direction === "rtl" ? "row-reverse" : "row"};
    flex-wrap: nowrap;
    height: 100%;
    min-height: 100vh;
    min-height: 100dvh;
    background-color: #ededed;
    position: relative;
    overflow: hidden;
  }

  .login {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-image: linear-gradient(
        135deg,
        transparent 0%,
        transparent 26%,
        ${thirdColor} 26%,
        ${thirdColor} 72%,
        transparent 72%,
        transparent 82%,
        ${primaryColor} 82%,
        ${primaryColor} 100%
      ),
      linear-gradient(
        45deg,
        transparent 0%,
        transparent 4%,
        ${primaryColor} 4%,
        ${primaryColor} 22%,
        ${secondaryColor} 22%,
        ${secondaryColor} 60%,
        transparent 60%,
        transparent 100%
      ),
      linear-gradient(90deg, rgb(255, 255, 255), rgb(255, 255, 255));
    position: relative;
  }

  .login_box {
    max-width: 400px;
    width: 100%;
    background-color: #fff;
    border-radius: 0.75rem;
    display: flex;
    flex-direction: column;
    border: 1px solid #f1f1f4;
    box-shadow: rgba(17, 12, 46, 0.15) 0px 48px 100px 0px;
    padding: 2.5rem;
    .text-gray-500 {
      color: #78829d;
      font-size: 0.8125rem;
      line-height: 1.125rem;
      margin-inline-end: 0.375rem;
      text-align: center;
      margin-bottom: 1.3rem;
    }
    .fw-bolder {
      text-align: center;
      margin-bottom: 1rem;
      color: #071437;
      font-size: 1.125rem;
      font-weight: 600;
    }
  }
  .sign-up-link {
    span {
      color: #78829d;
      font-size: 0.8125rem;
      line-height: 1.125rem;
      margin-inline-end: 0.375rem;
    }
    a {
      color: #1b84ff;
      font-size: 0.8125rem;
      text-decoration: inherit;
    }
  }
  .h-100 {
    height: 100%;
  }
  .sign-in {
    max-height: 580px !important;
  }
  .box-l {
    background-color: #ddd;
    position: relative;
    border: 2px solid transparent;
    background: #fff;
    background-clip: padding-box;
    border-radius: 20px !important;
    padding: 40px;
  }
  .box-l::before {
    content: "";
    background: #fff;
    position: absolute;
    z-index: -1;
    border-radius: 20px;
    box-shadow: 0 0 75px #dddddddb;
  }
  .mw-450px {
    max-width: 450px !important;
  }
  .text-center {
    text-align: center;
  }
  .head-title {
    font-weight: bold;
  }
  .head-subtitle {
    font-size: 14px;
    color: #656565;
    font-weight: 500;
    font-family: Inter;
  }
  .h-60px {
    height: 60px !important;
  }
  .h-50px {
    height: 50px !important;
  }

  .ant-input-outlined:focus-within {
    box-shadow: none;
  }
  .ant-input::placeholder {
    color: #b1b1b1;
  }

  .form-section {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    align-items: center;
    justify-content: center;
    padding: 24px 16px 72px;
    margin: 0;
    width: auto;
    min-width: 0;
    box-sizing: border-box;
    position: relative;
    z-index: 1;
    background-color: transparent;
    direction: ${({ theme }) => theme?.direction || "ltr"};
  }

  .login-card {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 450px;
    padding: 15px;
    padding-top: 13px;
    border-radius: 20px;
    background-color: #fff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
  }

  .login-card-inner {
    width: 100%;
  }

  .login-logo {
    text-align: center;

    img {
      width: 100px;
      max-width: 30vw;
      height: auto;
    }
  }

  .login-form {
    width: 100%;
    padding: 20px;
  }

  .login-form-body {
    padding: 16px;
  }

  .login-heading {
    text-align: center;
    margin-bottom: 20px;

    h1 {
      color: #212529;
      margin-bottom: 8px;
      font-size: 24px;
      font-weight: 500;
    }

    .login-subtitle {
      color: #6c757d;
      font-weight: 500;
      font-size: 16px;
    }
  }

  .login-footer-links {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 4px;
    text-align: center;

    span {
      color: #6c757d;
      font-weight: 500;
      font-size: 16px;
    }

    a {
      color: #212529;
      font-weight: 500;
      font-size: 16px;
      text-decoration: none;
    }
  }

  .login-footer-bar {
    position: absolute;
    bottom: 24px;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    direction: ltr; /* isolate from form RTL so order stays predictable */
    ${({ theme }) =>
      theme?.direction === "rtl"
        ? `
      left: 50px;
      right: 24px;
      flex-direction: row-reverse;
    `
        : `
      left: 24px;
      right: 50px;
      flex-direction: row;
    `}
  }

  .language-switcher {
    flex: 0 0 auto;
    order: 2;
  }

  .login-copyright {
    flex: 1 1 auto;
    order: 1;
    color: #6c757d;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.4;
    white-space: nowrap;
    text-align: ${({ theme }) =>
      theme?.direction === "rtl" ? "right" : "left"};

    strong {
      font-weight: 700;
      color: #495057;
    }
  }

  .bg-section {
    flex: 0 0 auto;
    align-self: stretch;
    height: 100vh;
    height: 100dvh;
    width: auto;
    z-index: 0;
    pointer-events: none;
    overflow: hidden;
    display: flex;
    align-items: stretch;
    justify-content: flex-end;

    .bg-image {
      height: 100%;
      width: auto;
      display: block;
      object-fit: contain;
      object-position: ${({ theme }) =>
        theme?.direction === "rtl" ? "left center" : "right center"};
    }
  }

  /* Tablet */
  @media (max-width: 1099px) and (min-width: 769px) {
    .form-section {
      flex: 0 0 100%;
      width: 100%;
      padding: 32px 24px 80px;
    }

    .bg-section {
      display: none;
    }
  }

  /* Mobile */
  @media (max-width: 768px) {
    .login-page {
      flex-direction: column;
    }

    .form-section {
      flex: 0 0 100%;
      width: 100%;
      max-width: 100%;
      padding: 16px 12px 80px;
      margin: 0;
      justify-content: flex-start;
      min-height: 100vh;
      min-height: 100dvh;
    }

    .login-card {
      max-width: 100%;
      margin-top: 8px;
      padding: 12px;
      border-radius: 16px;
    }

    .login-form {
      padding: 8px;
    }

    .login-form-body {
      padding: 8px;
    }

    .login-heading {
      margin-bottom: 16px;

      h1 {
        font-size: 20px;
      }

      .login-subtitle {
        font-size: 14px;
      }
    }

    .login-logo img {
      width: 80px;
    }

    .login-footer-links {
      span,
      a {
        font-size: 14px;
      }
    }

    .head-title {
      font-size: 19px;
    }

    .head-subtitle {
      font-size: 12px;
    }

    .bg-section {
      display: none;
    }

    .login-footer-bar {
      bottom: 16px;
      left: 12px;
      right: 12px;
    }

    .login-copyright {
      font-size: 13px;
      white-space: normal;
    }

    .sign-in {
      padding: 2rem !important;
    }

    .main-box {
      width: 100% !important;
      padding: 0.5rem !important;
    }

    .sidebox-img {
      display: none !important;
    }
  }

  /* Small phones */
  @media (max-width: 400px) {
    .form-section {
      padding: 12px 8px 72px;
    }

    .login-card {
      padding: 8px;
    }

    .login-heading h1 {
      font-size: 18px;
    }

    .login-heading .login-subtitle {
      font-size: 13px;
    }
  }

  /* Short viewports — keep switcher visible, allow form scroll */
  @media (max-height: 700px) {
    .form-section {
      justify-content: flex-start;
      padding-top: 16px;
      padding-bottom: 72px;
      overflow-y: auto;
    }

    .login-page {
      overflow: hidden;
    }
  }
`;
